import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const Testimonials: React.FC = () => {
  const testimonials = [{
    name: 'Valentina',
    age: 29,
    city: 'Córdoba',
    text: 'Recién recibida, me sentía muy perdida en las primeras sesiones. Este kit me dio el paso a paso exacto que necesitaba para no improvisar y ganar confianza rápido.'
  }, {
    name: 'Martín',
    age: 34,
    city: 'Buenos Aires',
    text: 'Llevo 5 años atendiendo y sentía que me faltaba estructura. El Método 4F me ordenó la cabeza y ahora mis pacientes notan un avance mucho más claro en cada encuentro.'
  }, {
    name: 'Camila',
    age: 31,
    city: 'Rosario',
    text: 'Estaba colapsada con tantos pacientes y poca organización. Las plantillas me salvaron la vida, ahora preparo cada sesión en 5 minutos y con un objetivo claro.'
  }, {
    name: 'Nicolás',
    age: 38,
    city: 'Mendoza',
    text: "Quería dejar de depender de 'a ver qué surge hoy'. Las intervenciones rápidas son oro puro para cuando la sesión se estanca o el paciente divaga."
  }, {
    name: 'Luciana',
    age: 27,
    city: 'La Plata',
    text: 'Empecé a atender hace poco y la ansiedad previa me mataba. Entrar a sesión sabiendo exactamente cómo abrir, guiar y cerrar no tiene precio.'
  }];
  return <section className="py-12 md:py-20 px-4 bg-navy-900" data-id="element-125">
      <div className="max-w-md md:max-w-6xl mx-auto" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-14" data-id="element-127">
          <h2 className="text-2xl md:text-4xl font-bold text-white" data-id="element-128">
            LO QUE DICEN <span className="text-gold-500" data-id="element-129">OTROS COLEGAS</span>
          </h2>
        </motion.div>

        <div className="space-y-4 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-6" data-id="element-130">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-800 p-5 md:p-6 rounded-xl md:rounded-2xl border border-navy-700" data-id="element-131">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-132">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold-500 text-gold-500" data-id="element-133" />)}
              </div>
              <p className="text-gray-300 italic text-sm md:text-base mb-4 md:mb-6" data-id="element-134">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-135">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-navy-700 flex items-center justify-center text-gold-500 font-bold text-sm border border-navy-600" data-id="element-136">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-137">
                  <p className="text-white font-bold text-sm" data-id="element-138">
                    {t.name}, {t.age} años
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-139">
                    Psicólogo/a en {t.city}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};